// @flow

import { gql } from '@apollo/client';

import useCustomMutation from 'routes/marketplace-ede/hooks/useCustomMutation';

const updatePolicyQuery = gql`
  mutation {
    UpdatePolicy {
      success
      action
    }
  }
`;

const useUpdatePolicyMutation = (options) =>
  useCustomMutation(updatePolicyQuery, options);

export default useUpdatePolicyMutation;
